export const COLLECTION_ADD = 'COLLECTION_ADD';
export const COLLECTION_UPDATE = 'COLLECTION_UPDATE';
